<template>
    <svg viewBox="0 0 65 113" class="grin-guy" :class="classlist">
        <g stroke="none" class="guy" stroke-width="1" fill-rule="evenodd">
            <path d="M13.0993881,105.123361 C14.8096392,101.035166 14.1081989,94.9031325 14.1081989,94.9031325 C12.6304556,81.3735697 13.6735673,58.6232221 13.6735673,58.6232221 C7.76260274,66.2928468 5.32867574,77.9265474 5.32867574,77.9265474 C5.93715734,78.9606542 5.58945353,79.6500587 4.63326782,80.8565164 C3.59015637,82.0629742 3.0686005,85.25147 3.0686005,85.25147 L2.72089669,88.2676146 C-1.79925349,83.8726611 2.37319287,76.8924408 2.37319287,76.8924408 C4.98097164,65.7757935 11.8481239,41.3019346 11.8481239,41.3019346 C11.8481239,41.3019346 11.9350497,35.0972945 12.1958269,28.2894253 C12.3696784,21.3953805 19.1499032,21.0506783 19.1499032,21.0506783 C25.6693508,20.8783272 39.4036549,20.705976 46.1838797,21.0506783 C52.9641045,21.4815561 53.3118075,27.6000208 53.3118075,27.6000208 L54.2679935,42.1636903 C54.2679935,42.1636903 61.3959213,31.477921 59.1358463,21.7400828 C57.7450316,15.621618 53.9202905,13.1225268 51.1386583,12.0884201 C51.0517325,14.4151602 48.8785833,14.5013358 48.8785833,14.5013358 C48.8785833,14.5013358 24.7131648,14.846038 21.6707582,14.846038 C18.6283488,14.846038 18.4544973,11.4851912 18.4544973,11.4851912 C18.4544973,11.4851912 17.93294,5.88377985 17.7590885,2.95381083 C17.6721628,0.0238418135 20.3668664,0.110017373 20.3668664,0.110017373 C20.3668664,0.110017373 42.27221,-0.0623337459 45.9230996,0.110017373 C49.6609179,0.282368492 49.8347693,2.60910859 49.8347693,2.60910859 L50.3563238,6.831711 C50.8778811,7.00406211 51.1386583,7.17641324 51.1386583,7.17641324 C79.6503752,23.2050673 53.8333648,53.5388641 53.7464391,53.7973909 C53.3987332,74.9104027 51.6602156,94.0413771 51.7471413,99.2119104 C51.8340671,104.382444 53.3118075,105.071849 53.3118075,105.071849 C53.3748822,105.140509 53.4358451,105.208001 53.4947392,105.274342 C60.3023567,106.080306 64.6121822,107.273527 64.6121822,108.605046 C64.6121822,111.032312 50.2903293,113 32.6234272,113 C14.9565278,113 0.634673506,111.032312 0.634673506,108.605046 C0.634673506,107.187687 5.51810118,105.927033 13.0993881,105.123361 Z M18.7935469,104.640934 C18.7993378,104.475992 18.8022003,104.303769 18.8022003,104.123918 C18.8022003,100.159842 19.6714605,91.1975837 26.0170538,90.2496524 C32.3626499,89.3017212 42.6199129,88.6123167 44.5322849,93.6966747 C46.4446569,98.7810328 47.05314,103.69304 47.05314,104.46862 C47.05314,104.530427 47.0547933,104.602086 47.0589423,104.681982 C42.7221711,104.380163 37.8173583,104.210093 32.6234272,104.210093 C27.6698319,104.210093 22.9792145,104.364788 18.7935469,104.640934 Z M33.1449845,29.2373564 C37.4043571,29.2373564 40.968321,32.6843787 40.968321,36.9931567 C40.968321,41.3019346 37.4912829,44.748957 33.1449845,44.748957 C28.798686,44.748957 25.3216479,41.3019346 25.3216479,36.9931567 C25.3216479,32.6843787 28.8856118,29.2373564 33.1449845,29.2373564 Z M33.4057617,64.741687 L33.6665389,64.741687 L33.2319102,64.741687 L33.4057617,64.741687 C21.3230524,64.1384578 18.3675716,53.5388641 18.9760517,51.8153531 C19.5845348,50.1780174 21.5838296,51.4706507 21.5838296,51.4706507 C25.5824251,54.5729709 32.1018727,54.6591465 33.4057617,54.6591465 L33.1449845,54.6591465 L33.5796131,54.6591465 L33.3188359,54.6591465 C34.6227249,54.6591465 41.1421725,54.5729709 45.140768,51.4706507 C45.140768,51.4706507 47.1400657,50.1780174 47.7485459,51.8153531 C48.4439546,53.4526885 45.4884709,64.1384578 33.4057617,64.741687 Z M13.0993881,105.123361 C12.8128372,105.80834 12.4585783,106.435942 12.0219754,106.967711 C12.0219754,106.967711 10.4573064,108.777398 13.9343474,108.605046 C17.2536315,108.358249 18.6717013,108.111452 18.7935469,104.640934 C16.7681202,104.77456 14.8609287,104.936625 13.0993881,105.123361 Z M47.0589423,104.681982 C47.1068478,105.604646 47.4870982,107.62588 49.4870664,108.260344 C51.7149836,108.93994 57.5751171,109.870758 53.4947392,105.274342 C51.5409373,105.043028 49.3813927,104.843613 47.0589423,104.681982 Z" id="Shape"></path>
        </g>
    </svg>
</template>
<script>
    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'GrinGuy',

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {
            /**
             * Whether or not the logo fill is white
             *
             * @type {object}
             */
            white: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * An additional class to add
             *
             * @type {object}
             */
            classes: {
                type: String,
                required: false,
                default: null
            }
        },

        /**
         * The component computed properties
         *
         * @type {object}
         */
        computed: {

            /**
             * The classlist
             *
             * @returns {object.boolean}
             */
            classlist() {
                return {
                    ['logo-white']: this.white,
                    [this.classes]: this.classes
                };
            }
        }
    }
</script>